define([
    "dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/comm/Aspera",
	"csi/comm/GetRequest",
	"csi/comm/PostRequest",
	"csi/store/Values",
	"csi/xml"
], function(declare,csi,_,Controller,Aspera,GetRequest,PostRequest,ValuesStore,xml) {

	return declare(Controller, {
		_preAction: function() {
			// summary: add any requests necessary to fetch data before executing action
			var self = this;
			var store1 = new ValuesStore({
				typeNode: "SRLineItem",
				requestParameters: {
					"Qry.Limit.Path": xml.getUrlPath(this.m_urlParent, xml.path("LineItems")),
					"Qry.Value.Attr": "PDF"
				}
			});

			var q1 = store1.query().then(function(results) {
				self.bResults1 = _.some(results, function(item) {
					return xml.isValidURL(store1.getIdentity(item));
				});
			});

			var store2 = new ValuesStore({
				typeNode: "SRLineItem",
				requestParameters: {
					"Qry.Limit.Path": xml.getUrlPath(this.m_urlParent, xml.path("LineItems")),
					"Qry.Value.Path": "Child:DocumentsAndComments/Child:Documents/Child:CurrentRevision",
					"Qry.Value.Attr": "File"
				}
			});

			var q2 = store2.query().then(function(results) {
				self.bResults2 = _.some(results, function(item) {
					return xml.isValidURL(store2.getIdentity(item));
				});
			});

			return [q1, q2];
		},

		preProcess: function() {
			// summary: allow action only if a line item references a data package
			if (this.bResults1 || this.bResults2)
				this.inherited(arguments);
			else
				this.displayErrorDialog({suffix:"_ErrorNoReferencedDPsOrDocuments"});
		},

		toWriter: function() {
			var request;
			if (Aspera.isEnabled()) {
				let transferSpec = null;
				request = new GetRequest("Sourcing", "DataPackageManyZipDownload")
					.addParameter("URL", this.m_urlParent)
					.get({handleAs: "json"}).then(
						(response) => {
							transferSpec = response.data;
							return Aspera.downloadFileFromSpec(transferSpec);
						}
					).then(
						function() {
							if (transferSpec) {
								let deleteRequest = new PostRequest("SiteAdmin", "DeleteDataPackageZip");
								deleteRequest.addParameter("FileName", transferSpec.transfer_specs[0].transfer_spec.paths[0].destination);
								return deleteRequest.post();
							} else {
								return null;
							}
						}
					).then(
						(msg) => {
							this.postProcess();
						}
					);
			} else {
				request = new GetRequest("Sourcing", "SupplierRequestDownloadManyLineItemZips")
				.addParameter("URL", this.m_urlParent);

				csi.browserWindow(request.toRequest(), "Sourcing");
			}
        }
	});
});